/**
 * Selector to loop through the sorted answers and filter by those which match
 * our provided array of questions. Basically a many-to-many intersection.
 *
 * This will by default include the subQuestions along with the questions.
 */

import { createSelectorCreator, lruMemoize } from 'reselect';
import { isEqual } from 'es-toolkit';

import getElectConsumptionDataSelector from './getElectConsumptionDataSelector';
import getElectLocationsSelector from './getElectLocationsSelector';

import type { ElectricityHeatSteamConsumptionDataDecorated } from './electHeatSteamTypes';

const createDeepEqualSelector = createSelectorCreator(lruMemoize, isEqual);

export default createDeepEqualSelector(
  [getElectConsumptionDataSelector, getElectLocationsSelector],
  (consumptionData, electLocations) => {
    return consumptionData.map((data) => {
      const attachedLocation = electLocations.find((loc) => loc.id === data.location_id);
      return {
        ...data,
        attachedLocation,
      } as ElectricityHeatSteamConsumptionDataDecorated;
    });
  },
);
